import { render, staticRenderFns } from "./closureAuditLists.vue?vue&type=template&id=99ff20b0&scoped=true"
import script from "./closureAuditLists.vue?vue&type=script&lang=js"
export * from "./closureAuditLists.vue?vue&type=script&lang=js"
import style0 from "./closureAuditLists.vue?vue&type=style&index=0&id=99ff20b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff20b0",
  null
  
)

export default component.exports